import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface State {
  id: string
  name: string
}

export interface UseStatesResult {
  states: State[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useStates(fetchOnMount = false): UseStatesResult {
  const [states, setStates] = useState<State[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ states: State[] }>('/admin/conversation-management/states/dropdown')
      console.log('States response:', res)
      setStates(res.states || [])
    } catch (e) {
      console.error('Failed to fetch states:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch states')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { states, loading, error, refetch }
}
